<template>
    <div>
        <ais-instant-search
            :search-client="searchClient"
            :index-name="index"
            :middlewares="middlewares"
            :routing="routing"
            :clickAnalytics="true"
            :insights="true"
        >
            <ais-configure
                :filters="searchFilters"
                :clickAnalytics="true"
                :analytics-tags.camel="['CATEGORY_LIST']"
                :enablePersonalization="true"
            />

            <!-- Filters -->
            <filter-panel-mobile :filters="categoryFilters"/>

            <div class="row">
                <filter-panel
                    :filters="categoryFilters"
                    class="col-12 col-md-4 col-lg-3 algolia-listing-filters d-none d-md-block"
                />
                <algolia-search-results
                    page-type="Category"
                    :lang-iso="langIso"
                    :user-token="userToken"
                    :action-banners="actionBanners"
                    class="col-12 col-md-8 col-lg-9"
                />
                <algolia-search-no-results category class="col-12 col-md-8 col-lg-9"/>
            </div>
        </ais-instant-search>
    </div>
</template>

<script>
import AlgoliaSearchResults from "./AlgoliaSearchResults";
import AlgoliaSearchNoResults from "./AlgoliaSearchNoResults";
import FilterPanelMobile from "./Partials/FilterPanelMobile";
import { AisConfigure, AisInstantSearch, AisRefinementList, AisSearchBox, } from "vue-instantsearch/vue3/es";
import {
    algoliaClientShortTTL,
    getAlgoliaInsightsAnonymousToken,
    getAlgoliaInsightsToken,
    index
} from "../../js/algoliaSettings";

import FilterPanel from "./Partials/FilterPanel";
import { createInsightsMiddleware } from "instantsearch.js/es/middlewares";
import aa from "search-insights";
import { history as historyRouter } from 'instantsearch.js/es/lib/routers';

const insightsMiddleware = createInsightsMiddleware({
    insightsClient: aa,
    insightsInitParams: {
        useCookie: true,
    }
});

export default {
    components: {
        AisSearchBox,
        FilterPanel,
        FilterPanelMobile,
        AisInstantSearch,
        AisRefinementList,
        AisConfigure,
        AlgoliaSearchResults,
        AlgoliaSearchNoResults
    },
    props: {
        categoryFilters: {
            type: Array,
            required: true,
            default: () => []
        },
        categoryId: {
            type: Number,
            required: false,
            default: 0
        },
        langIso: {
            type: String,
            required: false,
            default: 'nl-NL',
        },
        actionBanners: {
            type: Array,
            required: false,
            default: () => [],
        },
        userPersonalisationIdentifier: {
            type: Number,
            required: false,
            default: null,
        }
    },
    computed: {
        searchFilters() {
            if (this.categoryId) {
                return `categories.id_category:${this.categoryId}`;
            }
            return `id>0`;
        }
    },
    created() {
        this.configureAlgoliaInsights();

        if (document.getElementById("orders-button-bottom")) {
            document.getElementById("orders-button-bottom").classList.add('d-none');
        }

        if (document.getElementById("filters-button-bottom")) {
            document.getElementById("filters-button-bottom").classList.remove('d-none');
        }
    },
    methods: {
        configureAlgoliaInsights() {
            let userToken = getAlgoliaInsightsAnonymousToken();

            if (this.userPersonalisationIdentifier) {
                userToken = getAlgoliaInsightsToken(this.userPersonalisationIdentifier);
            }

            aa('setUserToken', userToken);
            this.userToken = userToken;
        }
    },
    data() {
        return {
            searchClient: algoliaClientShortTTL(),
            index: index(),
            userToken: null,
            middlewares: [insightsMiddleware],
            routing: {
                router: historyRouter({

                    createURL({ qsModule, routeState, location }) {

                        const queryParameters = {};

                        if (routeState.query) {
                            queryParameters.query = encodeURIComponent(routeState.query);
                        }
                        if (routeState.page !== 1) {
                            queryParameters.page = routeState.page;
                        }

                        if (routeState.refinementList) {
                            queryParameters.filter = routeState.refinementList;
                        }

                        const queryString = qsModule.stringify(queryParameters, {
                            addQueryPrefix: true,
                            arrayFormat: 'repeat'
                        });

                        return `${queryString}`;
                    },

                    parseURL({ qsModule, location }) {

                        const { query = '', page, filter = {} } = qsModule.parse(
                            location.search.slice(1)
                        );

                        for(const property in filter) {
                            const item       = filter[property];
                            filter[property] = Array.isArray(item) ? item : [item].filter(Boolean);
                        }

                        return {
                            query: decodeURIComponent(query),
                            page,
                            refinementList: filter,
                        };
                    }
                }),
                stateMapping: {
                    stateToRoute(uiState) {
                        const indexUiState = uiState[index()] || {};

                        return {
                            query: indexUiState.query,
                            page: indexUiState.page,
                            refinementList: indexUiState.refinementList,
                        };
                    },
                    routeToState(routeState) {
                        return {
                            [index()]: {
                                query: routeState.query,
                                page: routeState.page,
                                refinementList: routeState.refinementList
                            }
                        };
                    }
                },
            }
        };
    }
};
</script>
